// extracted by mini-css-extract-plugin
module.exports = {"container":"ProductRow_container__2o7cv","input":"ProductRow_input__1Q32B","inputInner":"ProductRow_inputInner__l_3wT"};